$(document).ready(function () {//Code Highlight for Code Tabs
    $('pre code').each(function (i, block) {
        hljs.highlightBlock(block);
    });

    var clipboard = new Clipboard('.copy-btn');
    clipboard.on('success', function (e) {
        e.clearSelection();
    });


    //Hide Unused Tabs
    $('.tab-content .tab-pane pre code').each(function () {
        if ($.trim($(this).html()).length == 0) {
            var tabHeaderToRemove = $(this).closest('div.tab-pane').attr("id");
            $('.nav-tabs').find('li a[href=' + '#' + tabHeaderToRemove + ']').parent().remove();
            $(this).closest('div.tab-pane').remove();
        }
    });

    $('body').find($('.code-tabs-light-theme')).each(function () {
        var currentAnchor = $(this).find('.nav-tabs li a');
        var currentTabPanel = $(this).find('.tab-content .tab-pane');
        currentAnchor.attr('href', currentAnchor.attr('href') + $(this).index());
        currentTabPanel.attr('id', currentTabPanel.attr('id') + $(this).index());

        //Set first as Active
        $(this).find('.nav-tabs li:first, .tab-content .tab-pane:first').addClass('active');

    });

});
